import { useTable, usePagination, useSortBy } from 'react-table';
import { FaSort, FaSortDown, FaSortUp } from 'react-icons/fa';
import { Spinner } from "reactstrap";
import { find, map } from "lodash";

import DropdownActions from "../dropdown/dropdown-actions";
import PaginationLocal from './pagination-local';
import NoData from '../table/no-data';

const LocalTable = (props) => {
  const {
    checkbox,
    columns,
    loading,
    data,
    actions,
    options,
    section,
    itemChecked,
    allItemsChecked,
    handleCheckOne,
    handleAllChecked,
    handleOpenDetails,
    handleOptionAction,
    handleAcceptNoData,
    rowSelected,
    emptyListInformer = 'large',
    className
  } = props
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
    },
    useSortBy,
    usePagination,
  )

  // Render the UI for your table
  return (
    <div className="qs-component-table-container">
      <div>
        {loading &&
          <div className="qs-table-container gm-table-loading">
            <Spinner />
          </div>
        }
        {!loading && data.length > 0 &&
          <div className={`qs-table-container ${!checkbox && 'qs-no-border'}`}>
            <table {...getTableProps()} cellSpacing={0}>
              <thead>
                {// Loop over the header rows
                  headerGroups.map((headerGroup, index) => (
                    // Apply the header row props
                    <tr key={`${index}-header`} {...headerGroup.getHeaderGroupProps()}>
                      {checkbox && <th className="gm-table-checkbox-container">
                        <div className='gm-table-checkbox'>
                          <input
                            type="checkbox"
                            id="cb-all"
                            onChange={handleAllChecked}
                            checked={allItemsChecked}
                          />
                        </div>
                      </th>}
                      {// Loop over the headers in each row
                        headerGroup.headers.map((column, index) => (
                          // Apply the header cell props
                          <th key={`${index}-header-group`} {...column.getHeaderProps(column.getSortByToggleProps())} className={ className || "qs-table-header"}>
                            <div className='gm-table-header-title'>
                              <span>
                                {column.canSort && !column.isSorted && <FaSort />}
                                {column.isSorted ? column.isSortedDesc ? <FaSortDown /> : <FaSortUp /> : ''}
                              </span>
                              {column.render('Header')}
                            </div>
                          </th>
                        ))}
                    </tr>
                  ))}
              </thead>
              {/* Apply the table body props */}
              <tbody {...getTableBodyProps()}>
                {// Loop over the table rows
                  page.map((row, rowInx) => {
                    // Prepare the row for display
                    prepareRow(row);
                    const checked = find(itemChecked, e => row.original.id === e.id);
                    const setActionTo = rowSelected?.id === row.original.id;
                    return (
                      // Apply the row props
                      <tr key={`${rowInx}-row`} {...row.getRowProps()} className={`${rowSelected && setActionTo && 'gm-tr-selected'}`}>
                        {checkbox && <td>
                          <div className='gm-table-body-checkbox'>
                            <input
                              type="checkbox"
                              id="cb-data"
                              checked={checked?.checked || false}
                              value={checked?.value}
                              onChange={(e) => handleCheckOne(e.target.checked, row.original)}
                            />
                          </div>
                        </td>}
                        {// Loop over the rows cells
                          row.cells.map((cell, index) => {
                            // Apply the cell props
                            return (
                              <td
                                key={`${index}-cell`}
                                {...cell.getCellProps()}
                                className="qs-table-body"
                                onClick={() => handleOpenDetails && cell.column?.type !== 'actions' && handleOpenDetails(row.original, rowInx)}
                              >
                                {cell.column?.type === 'actions' ?
                                  <div className="gm-table-action-container">
                                    {(map(actions, (e, index) => (
                                      e?.dropdown ?
                                        <div className='gm-actions-dropdown' key={`${index}-checkbox`}>
                                          <DropdownActions
                                            // options puede ser una función de la fila (opciones distintas por fila)
                                            options={typeof options === 'function' ? options(row.original) : options}
                                            handleOnClick={(action) => handleOptionAction(action, row.original)}
                                            Icon={e.icon}
                                            iconSize={16}
                                          />
                                        </div>
                                        :
                                        <button className={`gm-action-btn ${e?.className || ''}`} type='button' key={`${index}-action`} onClick={() => e.action(row.original)}>
                                          <e.icon size={16} />
                                        </button>
                                    )))}
                                  </div>
                                  :
                                  cell.render('Cell')
                                }
                              </td>
                            )
                          })}
                      </tr>
                    )
                  })}
              </tbody>
            </table>
          </div>
        }
        {data.length > 0 &&
          <PaginationLocal
            canPreviousPage={canPreviousPage}
            canNextPage={canNextPage}
            pageOptions={pageOptions}
            pageCount={pageCount}
            gotoPage={gotoPage}
            nextPage={nextPage}
            previousPage={previousPage}
            setPageSize={setPageSize}
            pageIndex={pageIndex}
            pageSize={pageSize}
          />
        }
      </div>

      {data.length === 0 && !loading &&
        <div className={`gm-nodata-main-container ${emptyListInformer === 'small' ? 'gm-small-container' : 'gm-large-container'}`}>
          <NoData section={section || ''} handleAcceptNoData={handleAcceptNoData} />
        </div>
      }
    </div>
  )
}

export default LocalTable;